import apiServices from "services/apiServices";
import { API } from "services/apiResource";
import handleRequest from "helpers/handleRequest";

export const createLog = data => {
    return async dispatch => {
        handleRequest(async () => {
            let { msg, error } = await apiServices.post(`${API.LOG.create}`, data);
            if (!msg) {
                throw error
            }
        }, () => { }, dispatch);
    };
};